import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import Layout from '../components/layout.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptop, faUserEdit, faGamepad, faTree } from '@fortawesome/free-solid-svg-icons';
import Image from '../components/image.js';
import WilliamAge from '../adhoc/william-age.js';
import AlexAge from '../adhoc/alex-age.js';
export const _frontmatter = {
  "layout": "about",
  "title": "About",
  "permalink": "/about/"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = props => {
  return <Layout {...props} icon="info" />;
};
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3>{`About Work`}</h3>
    <p>{`I'm currently a SW engineer @ `}<a parentName="p" {...{
        "href": "https://meta.com"
      }}>{`Meta`}</a>{` buiding Metaverse🌏. Before this role, I was AR/Avatar graphisc engineer @ `}<a parentName="p" {...{
        "href": "https://tiktok.com"
      }}>{`Tiktok`}</a>{`. Before 2021, I worked @ `}<a parentName="p" {...{
        "href": "http://www.bosch.us/content/language1/html/rtc.htm"
      }}>{`Bosch Research`}</a>{` productizing I4.0 & `}<a parentName="p" {...{
        "href": "https://www.bosch.us/media/our_company/innovation/visual-analytics-industry-4_res_1280x720.png"
      }}>{`eXplainable AI`}</a>{`, `}<a parentName="p" {...{
        "href": "https://www.bosch.us/media/our_company/innovation/3d-map-navigation_res_1280x720.jpg"
      }}>{`3D map`}</a>{`, & hand/`}<a parentName="p" {...{
        "href": "https://www.bosch.us/media/our_company/innovation/bosch-intelligent-glove_res_1984x1116.jpg"
      }}>{`glove`}</a>{` capturing etc. for ~6 years. Back in 2014, I was `}<a parentName="p" {...{
        "href": "https://www.amazon.com/"
      }}>{`Amazonian`}</a>{` working on its retail (hardline) website.`}</p>
    <p>{`My earlier industrial experience started at `}<a parentName="p" {...{
        "href": "https://www.ubisoft.com/en-GB/"
      }}>{`Ubisoft`}</a>{` in 2008 as a C++ software developer for `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Rayman"
      }}>{`Rayman`}</a>{` HD.
I have computer science, statistics and mathematics background and thus a "mixture" of `}<a parentName="p" {...{
        "href": "https://slackprop.wordpress.com/2013/06/03/on-geek-versus-nerd/"
      }}>{`geeky/nerdy`}</a>{` things. `}</p>
    <Image filename="coding.png" className="float-right-photo" style={{
      width: '10rem'
    }} mdxType="Image" />
    <p>{`I handed on lots of tech but never overfit my tech brain and here's the keywords I try to define my tech spectrum: `}<strong parentName="p">{`real-time/GPU`}</strong>{` (I spent lots of time with GPU and pipeline, shaders and CUDA, benchmark and performance), `}<strong parentName="p">{`AI`}</strong>{` (when deep learning/cnn becomes a thing), `}<strong parentName="p">{`full-stack/web`}</strong>{` (most product I did ends up with web UI), `}<strong parentName="p">{`scale/productization`}</strong>{` (make lab toys/demo practical), `}<strong parentName="p">{`engineering focus`}</strong>{` (mindset that engineering is also part of innovation). Even though LLM is taking over all these knowledge, but I believe all these training dots are to make me ready for something new in future.`}</p>
    <p>{`I love graphics, however, I'm a TUI guy when coming to coding, or more precisely a Vim+Tmux guy always carrying his `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/dotfiles"
      }}>{`backpack`}</a>{` until claude code comes.`}</p>
    {/*-
     I've recently been quite interested in deep learning, if you get any ideas or opportunities, please contact [me](/assets/cv/zeng-resume.html).
     ### About Me
     */}
    <h3>{`About Academy`}</h3>
    <p>{`In 2013, I graduated from `}<a parentName="p" {...{
        "href": "http://www.uiowa.edu/"
      }}>{`University of Iowa`}</a>{` as M.S. where I spent wonderful years studying high performance GPU rendering with my advisor `}<a parentName="p" {...{
        "href": "http://cwyman.org/"
      }}>{`Chris Wyman`}</a>{` as Ph.D. candidates. I also have M.S. degree in Probability and Mathematics Statistics and B.S. degree in Applied Mathematics from `}<a parentName="p" {...{
        "href": "http://www.scu.edu.cn/en/"
      }}>{`Sichuan University`}</a>{`, where I worked on theoretical research (statistics) of multi-sensor fusion with Prof. `}<a parentName="p" {...{
        "href": "https://scholar.google.com/citations?user=cN4yYyoAAAAJ&hl=en"
      }}>{`Yunmin Zhu`}</a>{`.`}</p>
    <h3>{`About Life`}</h3>
    <Image filename="william-code-abc.png" className="float-right-photo" style={{
      width: '10rem'
    }} mdxType="Image" />
    <p>{`We have two "lovely" kids living in bay area. As expected, `}<WilliamAge mdxType="WilliamAge" />{` while `}<AlexAge mdxType="AlexAge" />{`.`}</p>
    {/* (Wait, for quantum physics, I have my own interpretation regarding [this](https://www.youtube.com/watch?v=WIyTZDHuarQ) one).  */}
    <p>{`During weekends, I enjoy playing `}<FontAwesomeIcon icon={faLaptop} mdxType="FontAwesomeIcon" />{`, `}<FontAwesomeIcon icon={faGamepad} mdxType="FontAwesomeIcon" />{`, `}<FontAwesomeIcon icon={faUserEdit} mdxType="FontAwesomeIcon" />{` and sometimes go out to nature `}<FontAwesomeIcon style={{
        color: "green"
      }} icon={faTree} mdxType="FontAwesomeIcon" />{` for fresh air.`}</p>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      